/** How a regime's key date (a regulator's date, or a length of time it states) is named and valued
 * where it sits beside others. Pure: nothing here knows a regulator, counts down or states an amount. */

import type { components } from "../api/schema";
import { shortDate } from "./format";

export type KeyDate = components["schemas"]["KeyDateOut"];

/** The short value beside a label: the date for a watch row, the length for a period row. */
export function keyDateValue(item: KeyDate): string {
  if (item.kind === "watch_for" && item.expected_by) return shortDate(item.expected_by);
  if (item.period_days !== null) return `${String(item.period_days)} days`;
  if (item.period_years !== null) return `${String(item.period_years)} years`;
  return "";
}

/** What the entry is called where it sits beside others. */
export function keyDateName(item: KeyDate): string {
  return item.short_label ?? item.label;
}
